import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

import { IMAGE_ACCEPT } from '../../constants/variables';
import { Dropzone, Image, StyledTertiaryIcon, ImageUploaderContainer } from './styled';
import { ReactComponent as DefaultAvatar } from '../../assets/images/default-avatar.svg';
import { ReactComponent as DefaultLogo } from '../../assets/images/default-logo.svg';
import { ROUTE_FOR_ASSETS } from '../../constants/routes';

export const ImageUploader = ({
  avatar,
  name,
  setFieldValue,
  setFieldValueWithoutForm,
  isCompany = false
}) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: IMAGE_ACCEPT
  });

  const [file, setFile] = useState('');

  useEffect(() => {
    if (acceptedFiles.length) {
      setFieldValue && setFieldValue(name, acceptedFiles[0]);
      setFieldValueWithoutForm(acceptedFiles[0]);

      const reader = new FileReader();
      reader.onloadend = () => setFile(reader.result);
      reader.readAsDataURL(acceptedFiles[0]);
    } // eslint-disable-next-line
  }, [acceptedFiles, name, setFieldValue]);

  return (
    <ImageUploaderContainer>
      <Dropzone {...getRootProps()}>
        {avatar ?
          <Image src={file || `${ROUTE_FOR_ASSETS}${avatar}`} alt="Загруженая картинка" data-testid="Image"/>
         :
          isCompany ? <DefaultLogo data-testid="DefaultLogo" /> : <DefaultAvatar data-testid="DefaultAvatar"/>
        }
        <input name={name} {...getInputProps()} />
        <StyledTertiaryIcon />
      </Dropzone>
    </ImageUploaderContainer>
  );
};

ImageUploader.propTypes = {
  setFieldValue: PropTypes.func,
  setFieldValueWithoutForm: PropTypes.func,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  setChangeAvatar: PropTypes.func,
  isCompany: PropTypes.bool
};
